import { render } from "./SonicuSidebar.vue?vue&type=template&id=6129f8e1"
import script from "./SonicuSidebar.vue?vue&type=script&lang=js"
export * from "./SonicuSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__